import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _isNil from "lodash/isNil";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
var SampleTech = {
  PARSE_WT: 'parse',
  PARSE_TCR: 'parse_tcr',
  PARSE_BCR: 'parse_bcr',
  PARSE_BCR_WT: 'parse_bcr_wt',
  PARSE_TCR_WT: 'parse_tcr_wt',
  '10X': '10x',
  RHAPSODY: 'rhapsody',
  SEURAT: 'seurat',
  H5: '10x_h5',
  ANNDATA: 'anndata'
};
var ParseSampleTech = {
  WT: 'parse',
  TCR: 'parse_tcr',
  BCR: 'parse_bcr',
  BCR_WT: 'parse_bcr_wt',
  TCR_WT: 'parse_tcr_wt'
};
var validSampleTechs = new Set([SampleTech['10X'], SampleTech.RHAPSODY, SampleTech.SEURAT, SampleTech.H5, SampleTech.ANNDATA].concat(_toConsumableArray(Object.values(ParseSampleTech))));
var isParseSampleTech = function isParseSampleTech(tech) {
  return !_isNil(tech) && Object.values(ParseSampleTech).includes(tech);
};

// Techs uploaded as a single pre-built object file (Seurat .rds, AnnData .h5ad),
// rather than assembled from raw reads.
var preprocessedSampleTechs = [SampleTech.ANNDATA, SampleTech.SEURAT];
var isPreprocessedTech = function isPreprocessedTech(tech) {
  return !_isNil(tech) && preprocessedSampleTechs.includes(tech);
};
var techNamesToDisplay = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SampleTech['10X'], "10X Chromium".concat(String.fromCharCode(8482))), SampleTech.RHAPSODY, "BD Rhapsody".concat(String.fromCharCode(8482))), SampleTech.SEURAT, 'Seurat object (.rds)'), SampleTech.H5, "10X Chromium".concat(String.fromCharCode(8482), " - H5")), SampleTech.PARSE_WT, "Parse Evercode".concat(String.fromCharCode(8482))), SampleTech.PARSE_TCR, "Parse Evercode TCR".concat(String.fromCharCode(8482))), SampleTech.PARSE_BCR, "Parse Evercode BCR".concat(String.fromCharCode(8482))), SampleTech.PARSE_BCR_WT, "Parse Evercode BCR + WT".concat(String.fromCharCode(8482))), SampleTech.PARSE_TCR_WT, "Parse Evercode TCR + WT".concat(String.fromCharCode(8482))), SampleTech.ANNDATA, 'AnnData object (.h5ad)');
var metadataValuesByTechnology = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SampleTech.PARSE_WT, 'Parse Evercode WT'), SampleTech.PARSE_TCR, 'Parse Evercode TCR'), SampleTech.PARSE_BCR, 'Parse Evercode BCR'), SampleTech.PARSE_BCR_WT, 'Parse Evercode BCR + WT'), SampleTech.PARSE_TCR_WT, 'Parse Evercode TCR + WT'), SampleTech['10X'], '10X Chromium'), SampleTech.RHAPSODY, 'BD Rhapsody'), SampleTech.SEURAT, 'Seurat'), SampleTech.H5, '10X Chromium - H5'), SampleTech.ANNDATA, 'AnnData');
var getTechNameToDisplay = function getTechNameToDisplay(tech) {
  return techNamesToDisplay[tech];
};
var getSampleTechMetadataValue = function getSampleTechMetadataValue(tech) {
  return metadataValuesByTechnology[tech];
};
var ImmuneType = {
  TCR: 'TCR',
  BCR: 'BCR'
};
var getImmuneType = function getImmuneType(sampleTech) {
  if (sampleTech === SampleTech.PARSE_TCR_WT || sampleTech === SampleTech.PARSE_TCR) {
    return ImmuneType.TCR;
  }
  if (sampleTech === SampleTech.PARSE_BCR_WT || sampleTech === SampleTech.PARSE_BCR) {
    return ImmuneType.BCR;
  }
  return null;
};
var getIsPaired = function getIsPaired(sampleTech) {
  if ([SampleTech.PARSE_TCR_WT, SampleTech.PARSE_BCR_WT].includes(sampleTech)) {
    return true;
  }
  if ([SampleTech.PARSE_TCR, SampleTech.PARSE_BCR, SampleTech.PARSE_WT].includes(sampleTech)) {
    return false;
  }
  return null;
};
export default SampleTech;
export { ParseSampleTech, getTechNameToDisplay, getSampleTechMetadataValue, isParseSampleTech, validSampleTechs, getImmuneType, getIsPaired, preprocessedSampleTechs, isPreprocessedTech };